import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient, { formatApiError } from "@/api/client";

const PortalCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("crm_portal_token");
    if (!token) { setCustomer(null); setLoading(false); return; }
    try {
      const { data } = await apiClient.get("/portal/auth/me");
      setCustomer(data);
    } catch {
      localStorage.removeItem("crm_portal_token");
      setCustomer(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const { data } = await apiClient.post("/portal/auth/login", { email, password });
      localStorage.setItem("crm_portal_token", data.access_token);
      setCustomer(data.customer);
      return { ok: true };
    } catch (e) { return { ok: false, error: formatApiError(e) }; }
  };

  const logout = () => {
    localStorage.removeItem("crm_portal_token");
    setCustomer(null);
    window.location.href = "/portal/login";
  };

  return <PortalCtx.Provider value={{ customer, loading, login, logout, refresh: fetchMe }}>{children}</PortalCtx.Provider>;
}

export function usePortalAuth() {
  const ctx = useContext(PortalCtx);
  if (!ctx) throw new Error("usePortalAuth requires PortalAuthProvider");
  return ctx;
}
